import React from 'react';
import {
    WidgetsOutlined as PickIcon,
    SwapVertRounded as OrderIcon,
    StarOutlineRounded as DefaultIcon
} from '@mui/icons-material';
import styles from './HowItWorks.module.css';

const STEPS = [
    { key: 'pick', icon: <PickIcon fontSize="small" />, title: 'Escolha os módulos', text: 'Anotações, anamnese, medidas, escalas e outros cards.' },
    { key: 'order', icon: <OrderIcon fontSize="small" />, title: 'Defina a ordem', text: 'A tela de atendimento segue a ordem do tipo.' },
    { key: 'default', icon: <DefaultIcon fontSize="small" />, title: 'Marque um padrão', text: 'O tipo padrão é sugerido ao iniciar um atendimento.' }
];

/** Faixa curta que explica o que é um tipo de atendimento, em três passos ilustrados. */
function HowItWorks() {
    return (
        <ol className={styles.steps}>
            {STEPS.map((step, index) => (
                <li key={step.key} className={styles.step}>
                    <span className={styles.icon}>
                        {step.icon}
                        <span className={styles.number}>{index + 1}</span>
                    </span>
                    <span className={styles.text}>
                        <span className={styles.title}>{step.title}</span>
                        <span className={styles.hint}>{step.text}</span>
                    </span>
                </li>
            ))}
        </ol>
    );
}

export default HowItWorks;
